/* File: src/components/explanations/ShredNameExplanation.ts */
export const shredNameExplanation = `
<div class="text-gray-300 text-lg mb-4">

    <hr class="border-b-1 border-gray-600 my-2">
  
    <h2 class="text-blue-400 text-xl font-bold mb-2">1. What is This ?</h2>
    <p class="text-gray-200 text-base mb-4">
      This is where you give your shred a unique name. Think of it as the identifier that will help you and your team recognize what this shred does at a glance.
    </p>
    <h2 class="text-green-400 text-xl font-bold mb-2">2. Can i modify it ?</h2>
    <p class="text-gray-200 text-base mb-4">
      No, once created, the shred name cannot be changed as it will be used to generate the repository name. Choose carefully!
    </p>
    <h2 class="text-red-400 text-xl font-bold mb-2">3. What information should i include ?</h2>
    <p class="text-gray-200 text-base">
      Use a descriptive name that clearly indicates the shred's purpose. Include the main function or service it provides.
      <span class="chip">TIP</span> : Use names like "User Authentication API", "Payment Processing Service", or "Data Validation Engine" rather than vague names like "MyShred" or "API1".
    </p>
  
</div>
`;